import { themeColors } from "../../config.js";
export const menuStyle = {
  container: {
    position: "fixed",
    fontFamily: "roboto",
    backgroundColor: themeColors.optionColor,
    color: themeColors.optionTextColor,
    fontSize: 13,
  },
  option: {
    padding: 5,
  },
};
